import { uiRows } from './types-def.js';
/**
 * `web/after` (2.F; CS r5a deliverable 149): the session page's After tab, where captures are
 * resolved, tentative reveals decided, the recap written and the session finished. Every action
 * has a visible control (DECISIONS 161). The brief's `after.finish` is `after.session.finish` for the
 * three-part id grammar, as its test id is.
 */
export const AFTER_INTERACTIONS = uiRows([
    {
        id: 'after.capture.actions',
        module: 'web/after',
        behavior: "Each capture's menu offers its actions, and the one chosen is applied",
        owner: '2.F',
        since: 'exit-2b',
    },
    {
        id: 'after.reveal.decide',
        module: 'web/after',
        behavior: 'Each tentative reveal is confirmed or rejected by its own button',
        owner: '2.F',
        since: 'exit-2b',
    },
    {
        id: 'after.recap.open',
        module: 'web/after',
        behavior: '"Write recap" opens the session page at its Recap heading',
        owner: '2.F',
        since: 'exit-2b',
    },
    {
        id: 'after.session.finish',
        module: 'web/after',
        behavior: '"Finish" processes the session and plans the next one',
        owner: '2.F',
        since: 'exit-2b',
    },
    // CS r5b deliverable 165: the session's source files.
    {
        id: 'after.sources.upload',
        module: 'web/after',
        behavior: '"Choose file" or a drop on the drop zone uploads a source of the kind chosen in the segmented choice, with its progress shown',
        owner: '2.F',
        since: 'exit-2b',
    },
    {
        id: 'after.sources.remove',
        module: 'web/after',
        behavior: "Each source's Remove button removes it from the list",
        owner: '2.F',
        since: 'exit-2b',
    },
]);
//# sourceMappingURL=after.js.map